import { render, staticRenderFns } from "./BaseConfigMain.vue?vue&type=template&id=8fceac56&scoped=true"
import script from "./BaseConfigMain.vue?vue&type=script&lang=js"
export * from "./BaseConfigMain.vue?vue&type=script&lang=js"
import style0 from "./BaseConfigMain.vue?vue&type=style&index=0&id=8fceac56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fceac56",
  null
  
)

export default component.exports